import React, { useRef } from 'react';
import { PROPERTY_CARDS_PER_PAGE } from '../card-constants';
import { CardViewerAnimatedPages } from './card-viewer-animated-pages';
import { CardViewerPaginator } from './card-viewer-paginator';
import { CardViewerWrapper } from './card-viewer-styles';

interface Props {
  currentPage: number;
  propertyList: unknown[];
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

/** Component responsible for rendering a "Page" of cards with a slide animation and a Paginator at the bottom .*/
export function CardViewer(props: Props) {
  const { currentPage, propertyList, setCurrentPage } = props;

  // Reference to the current Page's container to programmatically scroll
  const paginationContainer = useRef<HTMLElement | null>(null);
  // Used for comparing previous page to current page to determine animation direction
  const previousPage = useRef<number>(0);

  return (
    <CardViewerWrapper>
      <CardViewerAnimatedPages
        currentPage={currentPage}
        previousPage={previousPage}
        paginationContainer={paginationContainer}
        propertyList={propertyList}
      />
      <CardViewerPaginator
        numPages={Math.ceil(propertyList.length / PROPERTY_CARDS_PER_PAGE)}
        paginationContainer={paginationContainer}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
      />
    </CardViewerWrapper>
  );
}
